import React, {Component} from 'react';
import {_addNotification, _addNotificationError, buildGradeName, formatDate,standardDateFormat,convertUTCDateToLocalDate} from "../../../server/util";
import {BeatLoader} from 'react-spinners'
import PropTypes from "prop-types";
import ParentBreakfastComponent from '../OrderMeals/parentBreakfastComponent';
import moment from  'moment';
var _ = require('lodash');
let schoolId=0;

class BreakfastView extends Component {
    constructor(){
        super();
        this.state={
            loading:false
        }
    }
    componentWillMount=()=>{
        const {sid} = this.context.router.route.match.params;
        schoolId=sid;

    }
    render(){
        return( 
        <section className="full-width clearfix">
        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
            <BeatLoader
                size={20}
                color={'#ea7066'}
                loading={this.state.loading}
            />
        </div>
       
        <div className="container ">
                    <div className="sectionTitle"> 
                    <div className="row">                      
                        <h2 style={{width:'auto'}}>
                            <span>Breakfast Menu</span>
                        </h2>
                            <button className="pull-right btn bg-color-4" style={{margin:'15px 0px 0px',color:'#ffffff'}} onClick={(e) => {
                                e.preventDefault();
                                let _self=this;
                                _self.context.router.history.goBack()
                               // window.location.replace('/parent');
                            }}><i class="fa fa-arrow-circle-left" aria-hidden="true"></i> Back</button>
                    </div>    
                    </div>
                    <div className="row">
                    </div>
                    <div className="row">
                    <div className="panel panel-primary">
                            <div className="panel-body">
            <ParentBreakfastComponent schoolId={schoolId} monthYear={moment().format('YYYYMM')} type={'breakfast'} />
        </div>
        </div>
        </div>
        </div>
        </section>)
    }
}
BreakfastView.contextTypes = {
    router: PropTypes.object.isRequired
}
export default BreakfastView;


// WEBPACK FOOTER //
// ./src/components/Parent/OrderMeals/breakfastView.jsx